module.exports = {"(^|\\.)espnfc\\.":"/football","(^|\\.)espncricinfo\\.":"/cricket"}


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/hostPaths.json
// module id = 811
// module chunks = 0